export default __webpack_public_path__ + "static/PdomnWjK-6b7e2bc25e6ab1265091356bd5d07474.jpeg";